<template>
  <div class='slide slide--self-assessment'>
    <div class='slide_label body-four-light'>
      {{ label }}
    </div>

    <!-- Intro -->
    <template v-if='!has_result'>
      <h2
        class='slide_headline h-two-light'
      >
        {{ activity.headline }}
      </h2>

      <div
        v-if='activity.instructions'
        class='slide_subheadline body-one-light'
      >
        {{ activity.instructions }}
      </div>

      <ConsentBox
        v-if='has_consent'
        :cta_action='take'
        :cta='activity.cta'
        :cta_class='"slide_cta"'
        :link_href='activity.consent_collection.link_href'
        :link_title='activity.consent_collection.link_title'
        :slide_result='slide_result'
        :updateSlideResult='updateResult'
      />

      <button
        v-if='!has_consent'
        class='slide_cta button-one-light'
        @click.prevent='take()'
      >
        {{ activity.cta }}
      </button>
    </template>

    <!-- Outro (Results) -->
    <template v-if='has_result'>
      <h2
        class='slide_headline h-two-light'
      >
        {{ outro_headline }}
      </h2>

      <div
        v-if='activity.instructions'
        class='slide_subheadline body-one-light'
        v-html='outro_content'
      />

      <a
        v-if='hero_outcome && outcome_href'
        :href='outcome_href'
        target='_blank'
        class='slide_cta button-one-light'
      >
        {{ activity.results.cta || hero_outcome.outcome.link.title }}
      </a>

      <a
        v-if='hero_outcome && !hide_outcomes'
        href='#results'
        class='slide--self-assessment_results link-one'
        role='button'
        @click.prevent='viewResult()'
      >
        {{ $t('view_self_assessment_result') }}
      </a>
    </template>
  </div>
</template>

<script>
import CommonMixin from './common-mixin'
import ResultsMixin from '../activity/activities/v2/SelfAssessment/results-mixin'
import ConsentBox from 'components/Shared/ConsentBox/ConsentBox.vue'

export default {
  mixins: [ResultsMixin, CommonMixin],

  components: {
    ConsentBox
  },

  methods: {
    take() {
      const event = {
        event: 'startSelfAssessment',
        pageCategory: 'activity-v2-self-assessment'
      }

      dataLayer.push(event)

      this.toggleActivityOverlay()
    },

    viewResult() {
      if (this.has_result) {
        dataLayer.push({
          event:        'viewSelfAssessmentResult',
          pageCategory: 'activity-v2-self-assessment'
        })
      }

      this.toggleActivityOverlay()
    },

    _resultsDeepCopy() {
      // deep copy
      this.activity_results = JSON.parse(JSON.stringify(this.slide_result.results.answers))
      this.categories = JSON.parse(JSON.stringify(this.slide_result.results.categories))
    }
  },

  watch: {
    'slide_result.status'(status) {
      if (status === 'passed' && Object.keys(this.slide_result.results).length) {
        this._resultsDeepCopy()
      }
    },

    'slide_result.event'(event) {
      if (event === 'finished' && Object.keys(this.slide_result.results).length) {
        this._resultsDeepCopy()
      }
    }
  },

  mounted() {
    if (this.slide_result.status === 'passed' &&
      Object.keys(this.slide_result.results).length &&
      this.slide_result.results.hasOwnProperty('answers')
    ) {
      this._resultsDeepCopy()
    }
  },

  computed: {
    has_result() {
      return this.slide_result.status === 'passed' &&
        Object.keys(this.slide_result.results).length &&
        this.slide_result.results.hasOwnProperty('answers')
    },

    has_consent() {
      return this.activity.consent_collection || false
    },

    outcome_href() {
      if (this.hero_outcome &&
       this.hero_outcome.outcome &&
       this.hero_outcome.outcome.link.href) {
        return this.hero_outcome.outcome.link.href
      }

      return false
    },

    label() {
      return this.activity.label || 'Self Assessment'
    },

    outro_headline() {
      if (this.hero_outcome && this.hero_outcome.outcome.hero_headline) {
        return this.hero_outcome.outcome.hero_headline
      }
      return this.activity.results.headline
    },

    outro_content() {
      if (this.hero_outcome && this.hero_outcome.outcome.hero_description) {
        return this.hero_outcome.outcome.hero_description
      }
      return this.activity.results.content
    },

    hide_outcomes() {
      return (this.hero_outcome &&
             this.hero_outcome.outcome.hide_outcomes) ||
             false
    }

  }
}
</script>

<style lang='sass' scoped>
@import './self-assessment-v2'
</style>
